import '@fontsource/poppins';

import { Grid, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import React, { useState } from 'react';

const options = [
  { value: 'General Practice', label: 'General Practice' },
  { value: 'Health Screening', label: 'Health Screening' },
  { value: 'Aesthetic', label: 'Aesthetic' },
  { value: 'A&E', label: 'A&E' },
  { value: 'Operating Theatre', label: 'Operating Theatre' },
  { value: 'Critical Care', label: 'Critical Care' },
  { value: 'High Dependency Ward', label: 'High Dependency Ward' },
  { value: 'General Ward', label: 'General Ward' },
  { value: 'Clinic', label: 'Clinic' },
  { value: 'Home Care', label: 'Home Care' },
  { value: 'School/Corporate', label: 'School/Corporate' },
  { value: 'Specialist Clinic', label: 'Specialist Clinic' },
];

export default function CreateClinicForm({
  groupData,
  createClinic,
  setCreateClinic,
  updateClinic,
  setUpdateClinic,
}) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const imgUrl = URL.createObjectURL(file);
    setSelectedFile(file);
    setPreviewUrl(imgUrl);
    setCreateClinic((prevcreateClinic) => ({
      ...prevcreateClinic,
      logo: file,
    }));

    // console.log('CA:', file, imgUrl);
  };
  const handleTypeChange = (event) => {
    const selectedValues = event.target.value || [];
    if (createClinic) {
      setCreateClinic({ ...createClinic, type: selectedValues });
    } else {
      setUpdateClinic({ ...updateClinic, type: selectedValues });
    }
  };

  const [firstChange, setFirstChange] = useState(true);

  const handlePhoneNumberChange = (ev) => {
    const {
      target: { name = 'companyTel', value, type: inputType },
    } = ev;

    let newValue = value;

    if (inputType === 'tel') {
      let cleanedInput = value.replace(/[^+\d]/g, (match, offset) => {
        return offset === 0 && match === '+' ? match : '';
      });

      if (!cleanedInput.startsWith('+')) {
        cleanedInput = `+${cleanedInput}`;
      }

      if (firstChange && cleanedInput.length === 2 && cleanedInput[1] !== '6') {
        cleanedInput = cleanedInput.replace('+', '');
        cleanedInput = `+65${cleanedInput}`;
        setFirstChange(false);
      }

      newValue = cleanedInput;
    }

    setCreateClinic((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const clinic = createClinic || updateClinic;
  const setClinic = createClinic ? setCreateClinic : setUpdateClinic;

  return (
    <Grid container spacing={4}>
      {/* Left Section */}
      <Grid item xs={12} md={6}>
        {/* Clinic Logo */}
        <Box px={4} py={1}>
          <Typography
            variant='subtitle1'
            sx={{ fontWeight: 'bold', color: 'gray.700', mb: 1 }}
          >
            Clinic Logo*
          </Typography>

          <Box
            sx={{
              width: 150,
              height: 150,
              overflow: 'hidden',
              borderRadius: 2,
              backgroundColor: 'grey.300',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <input
              type='file'
              accept='image/jpeg,image/png,image/webp,image/svg+xml'
              onChange={handleFileChange}
              id='upload-file-input'
              hidden
            />

            {selectedFile || previewUrl || clinic?.logo ? (
              <img
                src={previewUrl || clinic?.logo}
                alt='clinic logo'
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: 'center',
                }}
              />
            ) : null}
          </Box>

          <Box py={1}>
            <label htmlFor='upload-file-input'>
              <Button
                variant='contained'
                component='span'
                sx={{
                  textTransform: 'none',
                  backgroundColor: 'cyan.main',
                  '&:hover': { backgroundColor: 'cyan.dark' },
                }}
              >
                Upload Image
              </Button>
            </label>
          </Box>

          <Typography variant='caption' color='gray'>
            *size 150 x 150
          </Typography>
        </Box>

        {/* Clinic Name */}
        <Box px={4} py={1}>
          <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1 }}>
            Clinic Name*
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter Clinic Name'
            value={clinic?.clinicName || ''}
            onChange={(e) =>
              setClinic({ ...clinic, clinicName: e.target.value })
            }
          />
        </Box>

        {/* Initial */}
        <Box px={4} py={1}>
          <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1 }}>
            Initial
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter Initials'
            value={clinic?.initials || ''}
            onChange={(e) => setClinic({ ...clinic, initials: e.target.value })}
          />
        </Box>

        {/* Email */}
        <Box px={4} py={1}>
          <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1 }}>
            Clinic Email*
          </Typography>
          <TextField
            fullWidth
            placeholder='clinic@email.com'
            type='email'
            value={clinic?.corporateEmail || ''}
            onChange={(e) =>
              setClinic({ ...clinic, corporateEmail: e.target.value })
            }
          />
        </Box>

        {/* Telephone */}
        <Box px={4} py={1}>
          <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1 }}>
            Telephone Number*
          </Typography>
          <TextField
            fullWidth
            placeholder='+65'
            type='tel'
            name='companyTel'
            value={clinic?.companyTel || ''}
            onChange={handlePhoneNumberChange}
          />
        </Box>
      </Grid>

      {/* Right Section */}
      <Grid item xs={12} md={6}>
        {/* Clinic Address */}
        <Box px={4} py={1}>
          <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1 }}>
            Clinic Address*
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter Clinic Address'
            value={clinic?.clinicAddress || ''}
            onChange={(e) =>
              setClinic({ ...clinic, clinicAddress: e.target.value })
            }
          />
        </Box>

        {/* Country */}
        <Box px={4} py={1}>
          <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1 }}>
            Country*
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter Country'
            value={clinic?.country || 'Singapore'}
            onChange={(e) => setClinic({ ...clinic, country: e.target.value })}
          />
        </Box>

        {/* Location */}
        <Box px={4} py={1}>
          <FormControl fullWidth>
            <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1 }}>
              Location*
            </Typography>
            <Select
              value={clinic?.location || ''}
              displayEmpty
              onChange={(e) =>
                setClinic({ ...clinic, location: e.target.value })
              }
              renderValue={(selected) =>
                !selected ? (
                  <span style={{ color: '#8C8C8C' }}>Select</span>
                ) : (
                  selected
                )
              }
            >
              <MenuItem disabled value=''>
                <em style={{ color: '#8C8C8C' }}>Select</em>
              </MenuItem>
              <MenuItem value='central'>Central</MenuItem>
              <MenuItem value='east'>East</MenuItem>
              <MenuItem value='north'>North</MenuItem>
              <MenuItem value='north-east'>North East</MenuItem>
              <MenuItem value='west'>West</MenuItem>
              <MenuItem value='south'>South</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* CMS */}
        <Box px={4} py={1}>
          <FormControl fullWidth>
            <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1 }}>
              CMS
            </Typography>
            <Select
              value={clinic?.cms || ''}
              displayEmpty
              onChange={(e) => setClinic({ ...clinic, cms: e.target.value })}
              renderValue={(selected) =>
                !selected ? (
                  <span style={{ color: '#8C8C8C' }}>Select one</span>
                ) : (
                  selected
                )
              }
            >
              <MenuItem disabled value=''>
                <em style={{ color: '#8C8C8C' }}>Select one</em>
              </MenuItem>
              {[
                'Clinic Assist',
                'Plato',
                'GP connect',
                'SGiMED Hummingbird E-Clinic',
                'LinkDoctors',
                'Medical Suite',
                'Galen Helath',
                'HeartVoice',
                'OtterSG',
                'Julius',
                'UNO CMS',
              ].map((cms) => (
                <MenuItem key={cms} value={cms}>
                  {cms}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Clinic Type */}
        <Box px={4} py={1}>
          <FormControl fullWidth>
            <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1 }}>
              Clinic Type*
            </Typography>
            <Select
              multiple
              value={clinic?.type || []}
              displayEmpty
              onChange={handleTypeChange}
              renderValue={(selected) =>
                selected.length === 0 ? (
                  <span style={{ color: '#8C8C8C' }}>Select</span>
                ) : (
                  selected.join(', ')
                )
              }
            >
              {options?.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Description */}
        <Box px={4} py={1}>
          <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1 }}>
            Description*
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={5}
            placeholder='Enter Clinic Description'
            value={clinic?.description || ''}
            onChange={(e) =>
              setClinic({ ...clinic, description: e.target.value })
            }
          />
        </Box>
      </Grid>
    </Grid>
  );
}
